module.exports = __webpack_public_path__ + "static/media/menu.56f5997f.svg";